import React, { useEffect, useState } from "react";
import { Layout, Typography, Card, message } from "antd";
import { CopyOutlined, LinkOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";

const { Content, Sider } = Layout;
const { Title } = Typography;

// Convert company name to slug
const toSlug = (name) =>
  name
    ? name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "")
    : "";

function ViewLink() {
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);
  const [slugLink, setSlugLink] = useState("");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");

    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      const slug = toSlug(parsedUser.company_name);
      const finalLink = `https://www.meetingfix.com/organization/${parsedUser.company_id}/${slug}`;
      setSlugLink(finalLink);
    } else {
      message.error("User not found, please login again.");
    }
  }, []);

  if (!user) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(slugLink);
    message.success("Link copied to clipboard!");
  };

  return (
    <Layout
      style={{
        minHeight: "100vh",
        fontFamily: "Poppins, sans-serif",
        display: "flex",
      }}
    >
      {/* Sidebar – responsive collapse */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="md"
        collapsedWidth="0"
        width={220}
        style={{
          background: "#fff",
        }}
      >
        <Sidebar collapsed={collapsed} user={user} />
      </Sider>

      <Layout>
        <HeaderBar title="View Company Link" />

        <Content
          style={{
            margin: "20px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
          }}
        >
          <Card
            style={{
              width: "100%",
              maxWidth: 600,
              borderRadius: 12,
              padding: 20,
              boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
            }}
          >
            <Title level={4} style={{ textAlign: "center", marginBottom: 20 }}>
              Your Public Company Link
            </Title>

            {/* Link Section */}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "12px",
                textAlign: "center",
                wordBreak: "break-word",
              }}
            >
              <a
                href={slugLink}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  fontSize: 16,
                  color: "#1890ff",
                  fontWeight: 500,
                }}
              >
                {slugLink}
              </a>

              <div
                style={{
                  display: "flex",
                  gap: 25,
                }}
              >
                <CopyOutlined
                  onClick={handleCopy}
                  style={{
                    cursor: "pointer",
                    color: "#1890ff",
                    fontSize: 22,
                  }}
                />

                <LinkOutlined
                  onClick={() => window.open(slugLink, "_blank")}
                  style={{
                    cursor: "pointer",
                    color: "#1890ff",
                    fontSize: 22,
                  }}
                />
              </div>
            </div>
          </Card>
        </Content>

        <Footer user={user} />
      </Layout>
    </Layout>
  );
}

export default ViewLink;
